/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9348b4de (Tue Jan 13 18:25:19 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Playlist, PlaylistFromJSON, PlaylistToJSON } from './'

/**
 *
 * @export
 * @interface UpdatePlaylistNameResponse
 */
export interface UpdatePlaylistNameResponse {
  /**
   *
   * @type Playlist
   * @memberof UpdatePlaylistNameResponse
   */
  playlist: Playlist
}

export function UpdatePlaylistNameResponseFromJSON(
  json: any
): UpdatePlaylistNameResponse {
  return UpdatePlaylistNameResponseFromJSONTyped(json, false)
}

export function UpdatePlaylistNameResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdatePlaylistNameResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    playlist: PlaylistFromJSON(json['playlist']),
  }
}

export function UpdatePlaylistNameResponseToJSON(
  value?: UpdatePlaylistNameResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    playlist: PlaylistToJSON(value.playlist),
  }
}
